import { computed, reactive, watch } from "@vue/composition-api";
import { useStore } from "../../core/hooks";
import { requestsUseCase } from "../../core/usecases";
import { db } from "../../firebase";
import queries from './queries'

const usePendingsModal =  () => {
    const { state } = useStore()
    const userId = computed(() => state.value.user.uid)
    const pendingRequests = reactive({
        loading: false,
        data: null,
        length: null
    }) 
    pendingRequests.loading = true
    watch(userId, async (userId) => {
        if(!userId) {
            pendingRequests.data = false
            return
        }
        try { 
            const data = await requestsUseCase.getPendingRequests(queries.findPendingRequest(userId))
            pendingRequests.data = data.data.hits.slice(0,3).map(item => item._source)
            pendingRequests.length = data.data.hits.length
        }catch(e) {
            console.log(e);
        } finally {
            pendingRequests.loading = false
        }
    }, {immediate: true})
    const updateUserModel = () =>{
        const pendingModal = {
            showedTime: Date.now()
        }
        localStorage.setItem('pendingModal', JSON.stringify(pendingModal))
    }
    return {
        pendingRequests,
        updateUserModel
    }
}


export default usePendingsModal